exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ResetPasswordButton {\n  position: relative; }\n\n.ResetPasswordButton-prompt {\n  width: 480px;\n  background: #fefefe;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2); }\n  .ResetPasswordButton-prompt .TooltipCaret {\n    border-bottom-color: #fefefe !important; }\n\n.ResetPasswordButton-prompt-error {\n  color: #ef0043; }\n", ""]);

// exports
